import * as fetchJsonp from 'fetch-jsonp';

import { config } from './config';

export interface InstantPaymentResponse {
  paymentReference: string;
  request: {
    card_name: string;
    amount: number;
    reference: string;
  };
  response: any;
  success: boolean;
  message: string;
}

export const chargeCard = (
  paymentReference: string,
  amount: number,
  number,
  expiryMonth,
  expiryYear,
  cvc,
  nameOnCard,
): Promise<InstantPaymentResponse> => {
  const params = {
    CreditCardNumber: number,
    CreditCardExpiryMonth: expiryMonth,
    CreditCardExpiryYear: expiryYear,
    CreditCardCCV: cvc,
    NameOnCreditCard: nameOnCard,
    PaymentAmountInCents: amount,
    PaymentReference: paymentReference,
  };

  const url = new URL(`${config.apiLocation}/ChargeCard`);

  // Default params
  url.searchParams.set('PublicKey', config.publicKey);

  for (const key in params) {
    url.searchParams.set(key, params[key]);
  }

  const request = {
    'card_name': params.NameOnCreditCard,
    'amount': params.PaymentAmountInCents,
    'reference': params.PaymentReference
  };

  // Call api
  return fetchJsonp(url.toString(), { timeout: 30000 })
    .then(res => res.json())
    .then(data => {
      if (data.Error !== 0 || (data.Error === 0 && data.ErrorMessage === 'Declined')) {
        return {
          paymentReference,
          request,
          response: data.Data,
          success: false,
          message: `${data.Error}: ${data.ErrorMessage}`,
        };
      }

      return {
        paymentReference,
        request,
        response: data.Data,
        message: '',
        success: true,
      };
    });
};



// WEBPACK FOOTER //
// ./lib/ezidebit/chargeCard.ts